<template>
  <el-table
    :data="list"
    size="mini"
    row-class-name="defTableRowStyle"
    header-row-class-name="defTableHeaderStyle"
  >
    <el-table-column prop="name" label="合同名称" min-width="150" show-overflow-tooltip>
      <template slot-scope="{ row }">
        <span class="subject" @click="operate('chakan', row)">{{ row.subject }}</span>
      </template>
    </el-table-column>
    <el-table-column prop="name" label="合同编号" show-overflow-tooltip min-width="120">
      <template slot-scope="scope">
        <span>{{ scope.row.contractNo || "--" }}</span>
      </template>
    </el-table-column>
    <el-table-column
      prop="createdAt"
      label="合同状态"
      min-width="120"
      show-overflow-tooltip
    >
      <template slot-scope="scope">
        <qianshuIcon :value="scope.row.state" />
      </template>
    </el-table-column>
    <el-table-column prop="signers" label="签约时间" min-width="180">
      <template slot-scope="scope">
        <div>
          <div>
            发起：
            <span v-if="scope.row.createdAt">{{
              scope.row.createdAt | timeFormat("yyyy-mm-dd")
            }}</span>
            <span v-else>--</span>
          </div>
          <div>
            完成：
            <span v-if="scope.row.finishedAt">{{
              scope.row.finishedAt | timeFormat("yyyy-mm-dd")
            }}</span>
            <span v-else>--</span>
          </div>
        </div>
      </template>
    </el-table-column>

    <el-table-column prop="signers" label="签约方信息" min-width="190" v-if="!isIssue">
      <template slot-scope="scope">
        <signers :list="scope.row.signers" />
      </template>
    </el-table-column>
    <el-table-column prop="signers" label="签约方信息" min-width="190" v-if="isIssue">
      <template slot-scope="scope">
        <span>{{ tableSigners(scope) || "--" }}</span>
      </template>
    </el-table-column>
    <el-table-column prop="insuranceVersion" label="合同保障" min-width="120">
      <template slot-scope="scope">
        <div>
          <div v-if="scope.row.insuranceState || scope.row.insuranceSnapshot">
            <div>
              <hetongbaoIcon
                :value="scope.row.insuranceState"
                :item="scope.row"
                @buyClick="operate('hetongbao', scope.row)"
              />
            </div>
            <el-tooltip effect="dark" placement="top">
              <div style="width: 300px" slot="content" v-if="scope.row.insuranceSnapshot">
                {{ scope.row.insuranceSnapshot.detail }}
              </div>
              <p style="font-size: 12px; margin-top: -4px" class="pointer">
                {{ scope.row.insuranceSnapshot.title || "--" }}
              </p>
            </el-tooltip>
          </div>
          <div v-else>--</div>
        </div>
      </template>
    </el-table-column>
    <el-table-column
      prop="insuranceVersion"
      label="保障时间"
      min-width="120"
      v-if="!isIssue"
    >
      <template slot-scope="scope">
        <div v-if="!(scope.row.insuranceState == 0)">
          <div>
            <div v-if="scope.row.createdAt">
              <img
                src="~@/static/image/electronicDocuments/start.png"
                style="width: 12px; margin-right: 5px"
                alt=""
                srcset=""
              />{{ scope.row.createdAt | timeFormat }}
            </div>
            <span v-else>--</span>
          </div>
          <div>
            <div v-if="scope.row.insuranceUntil">
              <img
                src="~@/static/image/electronicDocuments/end.png"
                style="width: 12px; margin-right: 5px"
                alt=""
                srcset=""
              />{{ scope.row.insuranceUntil | timeFormat }}
            </div>
            <span v-else>--</span>
          </div>
        </div>
        <div v-else style="font-size: 12px">--</div>
      </template>
    </el-table-column>
    <el-table-column
      prop="address"
      label="归档管理"
      show-overflow-tooltip
      min-width="130"
      v-if="!isIssue"
    >
      <template slot-scope="{ row }">
        <div>
          <div @click="operate('guidang', row)" class="pointer guidang">
            <div class="ellipsis on" v-if="row.dirLabel">
              <img src="@/assets/image/icon_4.webp" alt="" srcset="" />
              <div>{{ row.dirLabel }}</div>
            </div>
            <div v-else class="off">
              <img src="@/assets/image/icon_4.webp" alt="" srcset="" />
              <div>待归档</div>
            </div>
          </div>
        </div>
      </template>
    </el-table-column>
    <el-table-column
      prop="address"
      label="操作"
      align="center"
      fixed="right"
      width="180px"
      v-if="!isIssue"
    >
      <template slot-scope="{ row }">
        <!-- <el-dropdown
          @command="(res) => operate(res, row)"
          trigger="click"
          placement="bottom"
        >
          <span class="el-dropdown-link pointer" style="font-size: 12px">
            <span class="el-icon-more"></span>
          </span>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item command="chexiao">撤销</el-dropdown-item>
            <el-dropdown-item command="xiazai">下载</el-dropdown-item>
            <el-dropdown-item command="chuzheng">出证</el-dropdown-item>
            <el-dropdown-item command="xiugai">修改名称</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown> -->

        <span class="pointer" @click="operate('chexiao', row)">撤销</span>
        <span style="color: #eee">｜</span>
        <span class="pointer" @click="operate('xiazai', row)" style="color: #0062ff"
          >下载</span
        >
        <!-- <span>｜</span>
        <span @click="operate('chuzheng', row)">出证</span> -->
        <span style="color: #eee">｜</span>
        <span class="pointer" @click="operate('xiugai', row)" style="color: #0062ff"
          >修改</span
        >
      </template>
    </el-table-column>
    <el-table-column
      prop="address"
      label="操作"
      align="center"
      fixed="right"
      width="180px"
      v-if="isIssue && !hindIssue"
    >
      <template slot-scope="{ row }">
        <span class="pointer primary" @click="operate('chuzheng', row)">申请出证</span>
      </template>
    </el-table-column>
  </el-table>
</template>

<script>
import qianshuIcon from "@/components/qianshuIcon";
import hetongbaoIcon from "@/components/hetongbaoIcon";
import signers from "./components/signers";

export default {
  components: {
    qianshuIcon,
    hetongbaoIcon,
    signers,
  },
  props: {
    list: {
      type: Array,
      default: () => [],
    },
    isIssue: {
      type: Boolean,
      default: false,
    },
    hindIssue: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    operate(type, data) {
      this.$emit("operate", { type, data });
    },
    tableSigners(scope) {
      return scope.row.signers.map((res) => res.operatorName).join("、");
    },
  },
};
</script>
<style lang="scss" scoped>
.guidang {
  display: flex;
  align-items: center;
  img {
    width: 16px;
    height: 16px;
  }
  .on,
  .off {
    display: flex;
    align-items: center;
    line-height: 1;
    gap: 4px;

    letter-spacing: 0em;
    text-decoration: underline;

    color: #0062ff;
  }
  .on {
    filter: grayscale(100%);
  }
  .ellipsis {
    white-space: nowrap;
    /* 确保文本在一行内显示 */
    overflow: hidden;
    /* 隐藏超出容器的文本 */
    text-overflow: ellipsis;
    /* 使用省略号表示被截断的文本 */
    // width: 170px;
    /* 定义容器宽度 */
  }
}
.subject {
  color: #0062ff;
  cursor: pointer;
}
</style>
